import axiosInstance from '../RestClient';

const BASE_URI = '/debts';
class DebtService {

	async list(params = {populate: true}) {
		const uri = `${BASE_URI}`;
		const response = await axiosInstance.get(uri, { params });
		return response;
	}

	async getDetails(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async create(payload) {
		const response = await axiosInstance.post(`${BASE_URI}/`, payload);
		return response;
	}

	async edit(recordId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/${recordId}`, payload);
		return response;
	}
	async editDate(recordId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/editDate/${recordId}`, payload);
		return response;
	}

	async delete(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.delete(uri);
		return response;
	}

	async getForWarranty() {
		const uri = `${BASE_URI}/forWarranty`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getDuesForDebt(debtId, params = {}) {
		const uri = `${BASE_URI}/debtDues/${debtId}`;
		const response = await axiosInstance.get(uri, { params });
		return response;
	}

	async refinanciar(debtId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/refinanciar/${debtId}`, payload);
		return response;
	}

	async sendDueReminder(dueId, payload = {}) {
		const response = await axiosInstance.post(`${BASE_URI}/debtDues/${dueId}/reminder`, payload);
		return response;
	}

	async search(params) {
		const uri = `${BASE_URI}/search`;
		const response = await axiosInstance.get(uri, { params });
		return response;
	}

	async searchReport(params) {
		const response = await axiosInstance.get(`${BASE_URI}/searchReport`, { params });
		return response;
	}

	async listForDashboard(params = {populate: true}) {
		const uri = `${BASE_URI}/dashboard`;
		const response = await axiosInstance.get(uri, { params });
		return response;
	}

	async getQuickPaymentEntities() {
		const uri = `${BASE_URI}/quickPaymentEntities`;
		const response = await axiosInstance.get(uri);
		return response;
	}
}
export default new DebtService();
